<template>
  <el-col :xs="24" :md="8" class="stat-card-item">
    <el-card class="stat-card">
      <div class="stat-content">
        <div class="stat-info">
          <div class="stat-title">{{ title }}</div>
          <div class="stat-value">{{ value }}</div>
        </div>
      </div>
    </el-card>
  </el-col>
</template>

<script>
export default {
  name: 'StatsCard',
  props: {
    title: { type: String, required: true },
    value: { type: [String, Number], default: '0' },

    chartId: { type: String, required: '' },
    chartType: { type: String, default: '' },
    chartData: { type: Array, default: () => [] }
  },
  mounted() {
  }
}
</script>

<style scoped>
.stat-card-item {
  margin-bottom: 20px;
}

.stat-card {
  height: 100%;
}

.stat-content {
  display: flex;
  align-items: center;
  padding: 15px;
}

.stat-info {
  flex: 1;
  text-align: center;
}

.stat-title {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 10px;
}

.stat-value {
  font-size: 24px;
  font-weight: 600;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
}

</style>